import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
    name: "cancel-subscription",
    computed: {
        ...mapGetters({
            canceledPlan: "userPaymentsHistory/canceledPlan",
        }),
    },
    methods: {
        ...mapActions({
            deleteTariff: "user/DELETE_USER_TARIFF",
        }),
        ...mapMutations({
            changeShowPopup: "userPaymentsHistory/CHANGE_POPUP_CANCEL_SUBSCRIPTION",
        }),
        cancelPlan(item) {
            try {
                this.deleteTariff(item).then(() => {
                    this.$toasted.success(this.$t("successDeleteTariff"));
                    this.changeShowPopup(false);
                });
            } catch (e) {
                console.log(e);
            }
        },
    },
};
